export default "__VITE_ASSET__B$$kEVjb__"